module.exports = __webpack_public_path__ + "media/images/Vector-24f081c993f9848085b84e52fb3ae6d3.svg";